import { render, staticRenderFns } from "./CospendSettingsDialog.vue?vue&type=template&id=7c0190ce&scoped=true&"
import script from "./CospendSettingsDialog.vue?vue&type=script&lang=js&"
export * from "./CospendSettingsDialog.vue?vue&type=script&lang=js&"
import style0 from "./CospendSettingsDialog.vue?vue&type=style&index=0&id=7c0190ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0190ce",
  null
  
)

export default component.exports